import { ReactNode } from 'react';
import { StyledPageLayoutBackground } from './styles';

interface PageLayoutBackgroundProps {
  children: ReactNode;
}

export const PageLayoutBackground = ({ children }: PageLayoutBackgroundProps) => {
  return <StyledPageLayoutBackground>{children}</StyledPageLayoutBackground>;
};
